(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-main"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;
    var jsonEl = root.querySelector('[data-pdp-json]');
    var product = null;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { product = null; }

    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var wasEl = root.querySelector('[data-pdp-price-was]');
    var badgeEl = root.querySelector('[data-pdp-badge]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var mainImg = document.getElementById('pdp-main-img');

    function money(cents) {
      return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
    }

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-pdp-option]'), function(group) {
        var active = group.querySelector('.pdp__option-value.is-active');
        return active ? active.getAttribute('data-option-value') : null;
      });
    }

    function findVariant(opts) {
      if (!product) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function swapImage(src) {
      if (!mainImg || !src) return;
      mainImg.style.opacity = '0';
      setTimeout(function() { mainImg.src = src; mainImg.style.opacity = '1'; }, 150);
    }

    function markSoldOut() {
      if (!product || product.options.length !== 1) return;
      root.querySelectorAll('.pdp__option-value').forEach(function(btn) {
        var v = findVariant([btn.getAttribute('data-option-value')]);
        btn.classList.toggle('is-soldout', !!v && !v.available);
      });
    }

    function applyVariant(v) {
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Seçenek mevcut değil'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      if (wasEl) { wasEl.hidden = !sale; if (sale) wasEl.textContent = money(v.compare_at_price); }
      if (badgeEl) badgeEl.hidden = !sale;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Sepete Ekle · ' + money(v.price) : 'Tükendi';
      }
      if (v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src;
        src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
        swapImage(src);
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('click', function(e) {
      var thumb = e.target.closest('[data-pdp-thumb]');
      if (thumb) {
        swapImage(thumb.getAttribute('data-pdp-thumb'));
        thumb.parentNode.querySelectorAll('.pdp__thumb').forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        return;
      }

      var qtyDown = e.target.closest('[data-qty-down]');
      var qtyUp = e.target.closest('[data-qty-up]');
      if (qtyDown || qtyUp) {
        var input = (qtyDown || qtyUp).parentNode.querySelector('[data-qty-input]');
        if (input) {
          var val = parseInt(input.value, 10) || 1;
          input.value = qtyDown ? Math.max(1, val - 1) : val + 1;
        }
        return;
      }

      var optBtn = e.target.closest('.pdp__option-value');
      if (optBtn) {
        optBtn.parentNode.querySelectorAll('.pdp__option-value').forEach(function(b) { b.classList.remove('is-active'); });
        optBtn.classList.add('is-active');
        applyVariant(findVariant(selectedOptions()));
      }
    });

    markSoldOut();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-reels]').forEach(function(root) {
      var track = root.querySelector('[data-reels-track]');
      var prev  = root.querySelector('[data-reels-prev]');
      var next  = root.querySelector('[data-reels-next]');
      if (!track || !prev || !next) return;

      function step() {
        var item = track.querySelector('.reels__item');
        if (!item) return 0;
        var gap = parseFloat(getComputedStyle(track).gap) || 16;
        return item.getBoundingClientRect().width + gap;
      }

      prev.addEventListener('click', function() {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function() {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      function updateNav() {
        var hasOverflow = track.scrollWidth > track.clientWidth + 2;
        if (!hasOverflow) {
          prev.hidden = true;
          next.hidden = true;
          return;
        }
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }

      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
      setTimeout(updateNav, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.related-section').forEach(function(root) {
      var row = root.querySelector('[data-rel-row]');
      var prev = root.querySelector('[data-rel-prev]');
      var next = root.querySelector('[data-rel-next]');
      if (!row || !prev || !next) return;

      function step() {
        var cell = row.querySelector('.related-section__cell');
        if (!cell) return 0;
        var gap = parseFloat(getComputedStyle(row).gap) || 16;
        return cell.getBoundingClientRect().width + gap;
      }

      prev.addEventListener('click', function() {
        row.scrollBy({ left: -step() * 2, behavior: 'smooth' });
      });
      next.addEventListener('click', function() {
        row.scrollBy({ left: step() * 2, behavior: 'smooth' });
      });

      function updateNav() {
        var hasOverflow = row.scrollWidth > row.clientWidth + 2;
        if (!hasOverflow) {
          prev.hidden = true;
          next.hidden = true;
          return;
        }
        prev.hidden = row.scrollLeft <= 2;
        next.hidden = row.scrollLeft >= row.scrollWidth - row.clientWidth - 2;
      }

      row.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
      setTimeout(updateNav, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
